import { Col, Row } from 'antd';
import SearchBarSuggestion from 'components/common/SearchBarSuggestion';
import React from 'react';
import { SearchScopeEnum } from 'redux/search/types';

import Filter from './Filter';
import { SearchBarContainerStyled } from './styled';

const SearchAndFilterBar: React.FC = () => (
  <Row className='gx-m-0 gx-p-0'>
    <Col className='gx-mr-3'>
      <Filter />
    </Col>
    <SearchBarContainerStyled flex='auto'>
      <SearchBarSuggestion
        placeholder='Search by User, Company...'
        entities={[SearchScopeEnum.COMPANY, SearchScopeEnum.USER]}
      />
    </SearchBarContainerStyled>
  </Row>
);

export default React.memo(SearchAndFilterBar);
